import getProductsBySerie from '@services/inventory/getProductsBySerie';
import getViewGame from '@services/inventory/getViewGame';
import getCustomGame from '@services/inventory/getCustomGame';
import getLotBySlug from '@helpers/getLotBySlug';
import BolaoPageOptions from './BolaoPageOptions';
import BoxBoloesSeries from './BoxBoloesSeries';
import CartApi from '../../Api/CartApi';
import PrizeCalc from './PrizeCalc';
import BoxBolaoInfo from './BoxBolaoInfo';
import VueTinySlider from 'vue-tiny-slider';
import AnimatedPlaceHolder from '../../6-components/Skeleton/AnimatedPlaceHolder.vue';
import BoxBolaoInfoSkeleton from './BoxBolaoInfoSkeleton.vue';
import InfoTextSkeleton from './InfoTextSkeleton.vue';
import './boloes-detail.scss';

(function (window) {
  'use strict';

  const elements = document.querySelectorAll('[data-vue=page-boloes-detail]');
  const instances = [];

  for (const $el of elements) {
    $el.setAttribute(
      'id',
      $el.getAttribute('id') || `bolao-page-detail_${instances.length}`
    );

    const vm = new Vue({
      el: $el,
      components: {
        'box-bolao-info': BoxBolaoInfo,
        'bolao-page-options': BolaoPageOptions,
        'box-boloes-series': BoxBoloesSeries,
        'prize-calc': PrizeCalc,
        'vue-tiny-slider': VueTinySlider,
        'animated-place-holder': AnimatedPlaceHolder,
        'box-bolao-info-skeleton': BoxBolaoInfoSkeleton,
        'info-text-skeleton': InfoTextSkeleton

      },
      data: {
        insidecart: null,
        updatecart: null,
        product: null,
        lottery: null,
        loaded: false,
        processingAdd: false,
        processingItem: true,
        loadedItem: false,
        game: null,
        selectedItemIndex: 0,
        selectedItem: null,
        pendingAdd: null,
        card: {
          bet: []
        },
        readonly: true,
        tinySliderOptions: {
          items: 1,
          center: false,
          autoplay: false,
          edgePadding: 0,
          autoplayButtonOutput: true,
          gutter: 20,
          loop: false,
          nav: true,
          controlsText: ['', '']
        },
        paymentMethods: [
          {
            icon: 'creditos',
            name: 'Meus Créditos'
          },
          {
            icon: 'pix',
            name: 'Pix'
          },
          {
            icon: 'cartao',
            name: 'Cartão de Crédito'
          },
          {
            icon: 'picpay'
          },
          {
            icon: 'ame'
          },
          {
            icon: 'boleto',
            name: 'Boleto'
          }
        ]

      },
      props: {
        bolao: {
          type: String,
          default () {
            return $el.getAttribute('data-bolao');
          }
        },
        draw: {
          type: String,
          default () {
            return $el.getAttribute('data-draw');
          }
        },
        lotterySlug: {
          type: String,
          default () {
            return $el.getAttribute('data-lottery-slug');
          }
        }
      },
      methods: {
        fetchInfo () {
          const lot = getLotBySlug(this.lotterySlug);

          const proms = [getProductsBySerie(`${this.bolao},${this.draw},${lot.special ? '1' : '0'}`), CartApi.getItems()];
          if (this.loaded) { this.loaded = false; }

          Promise.all(proms)
            .then(res => {
              const [game] = res;
              if (!game || !game.length) {
                window.location = `/${this.lotterySlug}/boloes`;
                return;
              }

              this.game = game[0];
              this.selectedItemIndex = 0;
              this.selectedItem = null;
              this.getItem(0);
              this.cart = res[1];
              this.insidecart = res[1]
              this.applyCart();
              this.loaded = true;
            })
            .catch((err) => {
              console.error(err);
            });

          const _self = this;

          getCustomGame(lot.id, lot.special)
            .then(function (response) {
              _self.lottery = response ? response.lottery : null;
              _self.drawInfo = response.nextDraw
                ? response.nextDraw
                : null;
            })
            .catch(function (err) {
              console.error(err);
            })
            .then(function () {
              _self.loaded = true;
            });
        },

        getItem (index = 0) {
          this.selectedItemIndex = index;

          if (!this.processingItem) { this.processingItem = true; }

          const { id, drawNumber, lotteryID } = this.game.items[index];

          getViewGame({
            productID: id,
            categoryID: 1,
            drawNumber: drawNumber,
            lotteryID: lotteryID,
            isOrdered: false
          })
            .then((res) => {
              this.selectedItem = res.game || null;
            })
            .catch((err) => {
              console.error(err);
              this.selectedItem = null;
            })
            .finally(() => {
              this.processingItem = false;
              this.loadedItem = true;
            });
        },
        setUnits (obj = { itemIndex, newUnits, isImmediately }) {
          let { itemIndex, newUnits, isImmediately } = obj;

          const products = this.game;

          const item = products.items[itemIndex];
          if (!item) {
            return;
          }

          const qty = item.myUnits;

          if (newUnits == '+') {
            newUnits = qty + 1;
          }
          if (newUnits == '-') {
            newUnits = qty - 1;
          }
          if (isNaN(parseInt(newUnits))) {
            newUnits = item.myUnits;
          }

          newUnits = parseInt(newUnits);

          if (!newUnits) {
            newUnits = 0;
          }
          if (newUnits > item.unitsInStock) {
            newUnits = item.unitsInStock;
          }

          if (newUnits <= item.unitsInStock && newUnits >= 0) {
            item.myUnits = newUnits;
          }

          if (this.pendingAdd) {
            clearTimeout(this.pendingAdd);
          }

          if (isImmediately) {
            this.addGame(itemIndex, false);
          }

          Vue.set(vm.game.items, itemIndex, item);
        },
        selectItem (itemIndex) {
          let newIndex = itemIndex;

          if (newIndex == this.selectedItemIndex) {
            return;
          }

          if (itemIndex == '+') {
            newIndex = this.selectedItemIndex + 1;
          }

          if (itemIndex == '-') {
            newIndex = this.selectedItemIndex - 1;
          }

          if (newIndex < 0) {
            newIndex = 0;
          }
          if (this.game && newIndex > this.game.items.length - 1) {
            newIndex = this.game.items.length - 1;
          }

          if (this.game && this.game.items.length) {
            this.getItem(newIndex)
          }
        },
        addGame (itemIndex, increase = true) {
          if (this.pendingAdd) {
            clearTimeout(this.pendingAdd);
          }

          if (this.processingAdd) {
            return;
          }

          const products = this.game;
          let item = null;
          try {
            item = products[itemIndex];
          } catch (e) {
            console.error('Item não encontrado.');
            return;
          }

          if (increase && item.myUnits == 0) {
            this.setUnits(itemIndex, 1);
          }

          if (increase) {
            const cartItem = this.cart.items.find(
              (a) =>
                a.productName == item.productName &&
                a.drawNumber == item.drawNumber
            );

            if (cartItem && cartItem.unitsAcquired == item.myUnits) {
              this.setUnits(itemIndex, '+');
            }
          }

          let itemsToProcess = [];

          const items = products.items.filter((a) => a.serie);
          itemsToProcess = itemsToProcess.concat(items);

          const proms = [];

          const itemsToAdd = [];

          itemsToProcess.forEach((item) => {
            const isUpdate =
              this.cart &&
              this.cart.items.find(
                (a) =>
                  a.productName == item.productName &&
                  a.drawNumber == item.drawNumber &&
                  a.inventoryId == item.inventoryId
              );
            if (isUpdate) {
              if (isUpdate.unitsAcquired != item.myUnits) {
                proms.push(
                  CartApi.update(
                    isUpdate.shoppingCartItemID,
                    item.myUnits,
                    false
                  )
                );
              }
            } else if (itemsToProcess[itemIndex].inventoryId === item.inventoryId) {
              itemsToAdd.push({ id: item.inventoryId, qty: item.myUnits, lotteryID: item.lotteryID });
            }
          });

          if (itemsToAdd.length) {
            proms.push(CartApi.add(itemsToAdd, 1, false, null, !!itemsToAdd.some((item) => item.lotteryID == 13)));
          }

          this.cart &&
            this.cart.items.forEach((a) => {
              if (
                a.categoryID == 1 &&
                a.lotteryID == this.game.lottery &&
                !itemsToProcess.find(
                  (item) =>
                    item.productName == a.productName &&
                    a.drawNumber == item.drawNumber
                )
              ) {
                proms.push(CartApi.update(a.shoppingCartItemID, a.unitsAcquired, false, this.game.lottery));
              }
            });

          if (!proms.length) {
            return;
          }

          this.processingAdd = true;

          Promise.all(proms)
            .then(() => {
              this.$toast.open({
                message: 'Itens atualizados.'
              });
            })
            .catch((err) => {
              this.$toast.open({
                type: 'error',
                message:
                  err && err.message
                    ? err.message
                    : 'Erro ao tentar atualizar.'
              });
            })
            .then(() => {
              CartApi.updateCart();
              this.processingAdd = false;
            });
        },
        applyCart () {
          if (!this.game) {
            return;
          }

          const cartItems = this.cart
            ? this.cart.items.filter((a) => a.categoryID == 1)
            : [];

          this.game.items.forEach((item) => {
            item.myUnits = 1;
            const cartItem = cartItems.find(
              (a) => a.productName == item.productName &&
                      a.productID == item.id
            );
            if (cartItem) {
              item.myUnits = cartItem.unitsAcquired;
            }
            return item;
          });

          Vue.set(vm.game, this.game);
        }
      },
      created () {
        this.fetchInfo();
        window.addEventListener('cart:update', (e) => {
          this.cart = e.detail;
          this.updatecart = this.cart.items.map((item) => item.productID)
          this.applyCart();
        });
      }
    });

    instances.push(vm);
  }
})(window);
